function toBrl(number) {
  return parseFloat(number).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}

export default toBrl;
